export default __webpack_public_path__ + "media/icons/angle_bold_left_black-0708b2a6.svg";